import React from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import Header from "./components/components/Header";
import AnimatedRoutes from "./components/AnimatedRoutes";
import MiniAudioPlayer from "./components/miniPlayer/MiniAudioPlayer";
import "./App.css"; // Import the CSS file for transitions

const AppContent = () => {
  const location = useLocation();
  const pathname = String(location?.pathname || '').toLowerCase();
  const inMusicRoute = pathname === '/music' || pathname.startsWith('/music/');

  return (
    <>
      <Header />
      <AnimatedRoutes />
      <MiniAudioPlayer embedded={inMusicRoute} headless={!inMusicRoute} lockOpen={inMusicRoute} startOpen={inMusicRoute} />
    </>
  );
};

const App = () => (
  <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <AppContent />
  </Router>
);

export default App;